const useErrors = () => {
  const errors = [];

  const captureErrors = (where, isCorrect) => {
    const index = errors.indexOf(where);
    const existsIndex = index >= 0;
    isCorrect ? (existsIndex && errors.splice(index, 1)) : (!existsIndex && errors.push(where));
  };

  return {
    errors,
    captureErrors
  }
}

export default useErrors